import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { _throw as throwError } from "rxjs/observable/throw";
import { catchError, tap, timeout } from 'rxjs/operators';
import { MessageService } from "./message.service";
import { Router } from "@angular/router";
import { StoreService } from './store.service';
import { TokenService } from './tokenService.service';
// const hostUrl = 'http://leaftest3.chinaeast2.cloudapp.chinacloudapi.cn/';
// const hostUrl = 'http://localhost:4355/';
// const hostUrl = '/';
var hostUrl = window.location.href.indexOf('yyddi') !== -1 ? '/yyddi/' : './';
var ApiService = (function () {
    function ApiService(http, messageService, storeService, tokenService, injector) {
        var _this = this;
        this.http = http;
        this.messageService = messageService;
        this.storeService = storeService;
        this.tokenService = tokenService;
        this.testEnvironment = [
            'localhost',
            'ttt.chinaeast2.cloudapp.chinacloudapi.cn',
            'leaftest3.chinaeast2.cloudapp.chinacloudapi.cn'
        ];
        this.outOfSurveillance = [
            'sr/exposeoutapi/adderrormsg',
            'v1/configuration/',
            'v1/heartbeat/'
        ];
        this.headerObj = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
        //这里设置是作用于刷新时直接从localStorage里取token
        this.httpOptions = {
            headers: new HttpHeaders(this.updateHeaders())
        };
        this.versionUrl = hostUrl + 'assets/version.json';
        this.charaterSurveyUrl = hostUrl + 'api/{1}/surveys';
        this.answerQuestionUrl = hostUrl + 'sr/coursedna/surveys/{1}'; //dna答题
        this.updateSurveyUrl = hostUrl + 'api/surveys/{1}';
        this.tickInitUrl = hostUrl + 'ddilearner/v1/user/tick/init'; //倒计时初始化
        this.tickUpdateSurveyUrl = hostUrl + 'ddilearner/v1/user/tick/update/{1}'; //倒计时更新
        this.tickResetUrl = hostUrl + 'ddilearner/v1/user/tick/reset'; //倒计时重置
        this.finishSurveyUrl = hostUrl + 'sr/coursedna/{1}/finishSurvey/{2}'; //dna完成
        this.resetDNASurveyUrl = hostUrl + 'sr/coursedna/surveys/{1}/reset'; //dna重做
        this.dnaReportUrl = hostUrl + 'sr/coursedna/surveys/{1}/report'; //dna报告
        this.resetSurveyUrl = hostUrl + 'api/surveys/{1}/reset';
        this.reportUrl = hostUrl + 'api/surveys/{1}/report';
        this.getCompanyListUrl = hostUrl + 'ddilearner/v1/user/companylist'; //获取公司列表
        this.createLearningPathUrl = hostUrl + 'ddilearner/v1/{1}/learningpathes';
        this.updateLearningPathStatusUrl = hostUrl + 'api/learningpathes/{1}';
        this.createPracticeUrl = hostUrl + 'api/{1}/practices';
        this.getPracticeUrl = hostUrl + 'api/practices/{1}';
        this.getPracticeByMetaIdUrl = hostUrl + 'api/{1}/practice';
        this.practiceReportUrl = hostUrl + 'api/practices/{1}/report';
        this.startNextCaseUrl = hostUrl + 'api/practices/{1}/startNextCase';
        this.updatePracticeStatusUrl = hostUrl + 'api/practices/{1}';
        this.answerQuizQuestionUrl = hostUrl + 'api/quizzes/{1}';
        this.finishQuizUrl = hostUrl + 'api/quizzes/{1}/finish';
        this.resetQuizUrl = hostUrl + 'api/quizzes/{1}/reset';
        this.resetExerciseUrl = hostUrl + 'api/exercises/{1}/reset';
        this.answerExerciseQuestionUrl = hostUrl + 'api/exercises/{1}';
        this.finishExerciseUrl = hostUrl + 'sr/exercises/{1}/finish';
        this.createCourseUrl = hostUrl + 'api/{1}/courses';
        this.getCourseUrl = hostUrl + 'api/courses/{1}';
        this.getCourseByMetaIdUrl = hostUrl + 'api/{1}/course';
        this.finishLessonUrl = hostUrl + 'api/lessons/{1}/finish/{2}';
        this.getGraduationUrl = hostUrl + 'api/graduation/{1}/{2}';
        this.updateFeedbackPopedUrl = hostUrl + 'api/learningpathes/{1}/feedback';
        this.addFeedbackUrl = hostUrl + 'api/feedbacks';
        this.getHrReportsUrl = hostUrl + 'api/hrReports';
        this.getCompanyReportUrl = hostUrl + 'api/companyReport';
        this.checkRegisterUrl = hostUrl + 'api/checkRegister';
        this.sendCodeUrl = hostUrl + 'ddilearner/v1/sms/send';
        this.loginInPhoneOrAccountUrl = hostUrl + 'ddilearner/v1/user/login';
        this.validateProtectionAccountUrl = hostUrl + 'ddilearner/v1/user/validateProtectionAccount';
        this.updatePasswordUrl = hostUrl + 'ddilearner/v1/user/updatePassword';
        this.getUserInfoUrl = hostUrl + 'ddilearner/v1/user/userinfo';
        this.logoutUrl = hostUrl + 'ddilearner/v1/user/logout';
        this.applyUrl = hostUrl + 'api/apply';
        this.registerUserUrl = hostUrl + 'api/register';
        this.wechatConfigUrl = hostUrl + 'api/jsapi';
        this.getUserStatusAskingDurationUrl = hostUrl + 'ddilearner/v1/user/loginstatus/interval';
        this.getLearningPathMetaIdByPathIdUrl = hostUrl + 'ddilearner/v1/getLearningPathMetaId/{1}';
        this.exerciseId = 0;
        setTimeout(function () { return _this.router = injector.get(Router); });
    }
    //这里暴露方法是为了在登录后手动从localStorage里取token
    ApiService.prototype.setHeaders = function () {
        this.httpOptions = {
            headers: new HttpHeaders(this.updateHeaders())
        };
        console.log('httpOptions', this.httpOptions);
    };
    ApiService.prototype.updateHeaders = function () {
        this.headerObj['transtalen-token'] = this.tokenService.findToken();
        this.headerObj['transtalenuserid'] = this.tokenService.findUserIdEncoder();
        return this.headerObj;
    };
    //获取影响力进度
    ApiService.prototype.getProgress = function (exerciseId) {
        return this.http.get(hostUrl + ("sr/exercise/getExerciseProgress/" + exerciseId), this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    //存储影响力进度
    ApiService.prototype.saveProgress = function (data) {
        return this.http.post(hostUrl + "sr/exercise/saveExerciseProgress", data, this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    //存储时间
    ApiService.prototype.learingTime = function (data) {
        return this.http.post(hostUrl + "ddilearner/v1/user/event/click", data, this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    ApiService.prototype.getCustomizeMetaInfo = function () {
        return this.http.get(hostUrl + "sr/customized/getCompanyLogo", this.httpOptions)
            .pipe(catchError(this.handleError('getCompanyLogo', null)));
    };
    ApiService.prototype.getCompanyList = function () {
        return this.http.get(this.getCompanyListUrl, this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    ApiService.prototype.getWechatConfig = function (data) {
        return this.http.post(this.wechatConfigUrl, data, this.httpOptions)
            .pipe(catchError(this.handleError('getWechatConfig', null)));
    };
    ApiService.prototype.getOrCreateSurvey = function (surveyMetaId, learningPathId, learningTourId) {
        return this.http.post(this.charaterSurveyUrl.replace("{1}", surveyMetaId), { learningPathId: learningPathId, learningTourId: learningTourId }, this.httpOptions)
            .pipe(catchError(this.handleError('getOrCreateSurvey', null)));
    };
    ApiService.prototype.answerQuestion = function (surveyId, questionId, optionId) {
        return this.http.post(this.answerQuestionUrl.replace("{1}", surveyId), { questionId: questionId, optionId: optionId }, this.httpOptions)
            .pipe(catchError(this.handleError('answerQuestion', null)));
    };
    ApiService.prototype.resetDNASurvey = function (surveyId) {
        return this.http.post(this.resetDNASurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('resetSurvey', null)));
    };
    ApiService.prototype.resetSurvey = function (surveyId) {
        return this.http.put(this.resetSurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('resetSurvey', null)));
    };
    ApiService.prototype.tickInit = function (tickInitType) {
        return this.http.post(this.tickInitUrl + '/' + tickInitType, { type: tickInitType }, this.httpOptions)
            .pipe(catchError(this.handleError('tickInit', null)));
    };
    ApiService.prototype.tickReset = function (tickInitType) {
        return this.http.post(this.tickResetUrl + '/' + tickInitType, { type: tickInitType }, this.httpOptions)
            .pipe(catchError(this.handleError('tickInit', null)));
    };
    ApiService.prototype.tickUpdateSurveyTime = function (surveyId) {
        return this.http.post(this.tickUpdateSurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('tickUpdate', null)));
    };
    ApiService.prototype.updateUsedTime = function (surveyId, usedTime) {
        return this.http.put(this.updateSurveyUrl.replace("{1}", surveyId), { usedTime: usedTime }, this.httpOptions)
            .pipe(catchError(this.handleError('updateUsedTime', null)));
    };
    ApiService.prototype.finishSurvey = function (surveyId, type) {
        return this.http.post(this.finishSurveyUrl.replace("{1}", surveyId).replace("{2}", type), {}, this.httpOptions)
            .pipe(catchError(this.handleError('finishSurvey', null)));
    };
    ApiService.prototype.getDNAReport = function (surveyId) {
        return this.http.get(this.dnaReportUrl.replace("{1}", surveyId), this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    ApiService.prototype.getReport = function (surveyId) {
        return this.http.get(this.reportUrl.replace("{1}", surveyId), this.httpOptions)
            .pipe(catchError(this.handleError('getReport', null)));
    };
    ApiService.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.http.post(this.createLearningPathUrl.replace("{1}", learningPathMetaId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('getOrCreateLearningPath', null)));
    };
    ApiService.prototype.updateLearningPathStatus = function (learningPathId) {
        return this.http.put(this.updateLearningPathStatusUrl.replace("{1}", learningPathId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('updateLearningPathStatusUrl', null)));
    };
    ApiService.prototype.createPractice = function (learningPathId) {
        return this.http.post(this.createPracticeUrl.replace("{1}", learningPathId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('createPractice', null)));
    };
    ApiService.prototype.getLearningPathMetaIdByPathId = function (learningPathId) {
        return this.http.get(this.getLearningPathMetaIdByPathIdUrl.replace("{1}", learningPathId), this.httpOptions)
            .pipe(catchError(this.handleError('getPractice', null)));
    };
    ApiService.prototype.getPractice = function (practiceId) {
        return this.http.get(this.getPracticeUrl.replace("{1}", practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('getPractice', null)));
    };
    ApiService.prototype.getPracticeByMetaId = function (practiceMetaId) {
        return this.http.post(this.getPracticeByMetaIdUrl.replace("{1}", practiceMetaId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('getPracticeByMetaId', null)));
    };
    ApiService.prototype.updatePracticeStatus = function (practiceId) {
        return this.http.put(this.updatePracticeStatusUrl.replace("{1}", practiceId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('updatePracticeStatus', null)));
    };
    ApiService.prototype.getPracticeReport = function (practiceId) {
        return this.http.get(this.practiceReportUrl.replace("{1}", practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('getPracticeReport', null)));
    };
    ApiService.prototype.startNextCase = function (practiceId) {
        return this.http.patch(this.startNextCaseUrl.replace("{1}", practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('startNextCase', null)));
    };
    ApiService.prototype.resetQuiz = function (quizId) {
        return this.http.put(this.resetQuizUrl.replace("{1}", quizId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('resetQuiz', null)));
    };
    ApiService.prototype.resetExercise = function (exerciseId) {
        return this.http.put(this.resetExerciseUrl.replace("{1}", exerciseId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('resetExercise', null)));
    };
    ApiService.prototype.answerQuizQuestion = function (quizId, questionId, optionId) {
        return this.http.patch(this.answerQuizQuestionUrl.replace("{1}", quizId), { questionId: questionId, optionId: optionId }, this.httpOptions)
            .pipe(catchError(this.handleError('answerQuestion', null)));
    };
    ApiService.prototype.answerExerciseQuestion = function (exerciseId, questionId, optionId) {
        return this.http.post(this.answerExerciseQuestionUrl.replace("{1}", exerciseId), { questionId: questionId, optionId: optionId }, this.httpOptions)
            .pipe(catchError(this.handleError('answerQuestion', null)));
    };
    ApiService.prototype.finishQuiz = function (quizId) {
        return this.http.put(this.finishQuizUrl.replace("{1}", quizId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('answerQuestion', null)));
    };
    ApiService.prototype.finishExercise = function (exerciseId) {
        return this.http.put(this.finishExerciseUrl.replace("{1}", exerciseId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('answerQuestion', null)));
    };
    ApiService.prototype.createCourse = function (learningPathId) {
        return this.http.post(this.createCourseUrl.replace("{1}", learningPathId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('createCourse', null)));
    };
    ApiService.prototype.getCourse = function (courseId) {
        return this.http.get(this.getCourseUrl.replace("{1}", courseId), this.httpOptions)
            .pipe(catchError(this.handleError('getCourse', null)));
    };
    ApiService.prototype.getCourseByMetaId = function (courseMetaId) {
        return this.http.post(this.getCourseByMetaIdUrl.replace("{1}", courseMetaId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('getCourseByMetaId', null)));
    };
    ApiService.prototype.finishLesson = function (lessonId, externalId) {
        return this.http.put(this.finishLessonUrl.replace("{1}", lessonId).replace("{2}", externalId), {}, this.httpOptions);
        // .pipe(catchError(this.handleError('finishLesson', null))
        // );
    };
    ApiService.prototype.getGraduationByLearningPathId = function (learningPathId, userId) {
        return this.http.get(this.getGraduationUrl.replace("{1}", learningPathId).replace("{2}", userId), this.httpOptions)
            .pipe(catchError(this.handleError('getGraduationByLearningPathId', null)));
    };
    ApiService.prototype.updateFeedbackPoped = function (learningPathId) {
        return this.http.put(this.updateFeedbackPopedUrl.replace("{1}", learningPathId), {}, this.httpOptions)
            .pipe(catchError(this.handleError('updateFeedbackPoped', null)));
    };
    ApiService.prototype.addFeedback = function (level, comment) {
        return this.http.post(this.addFeedbackUrl, { level: level, comment: comment }, this.httpOptions)
            .pipe(catchError(this.handleError('addFeedback', null)));
    };
    ApiService.prototype.getHrReports = function () {
        return this.http.get(this.getHrReportsUrl, this.httpOptions)
            .pipe(catchError(this.handleError('getHrReports', null)));
    };
    ApiService.prototype.getCompanyReport = function () {
        return this.http.get(this.getCompanyReportUrl, this.httpOptions)
            .pipe(catchError(this.handleError('getCompanyReport', null)));
    };
    ApiService.prototype.checkRegister = function () {
        return this.http.get(this.checkRegisterUrl, this.httpOptions)
            .pipe(catchError(this.handleError('sendCode', null)));
    };
    ApiService.prototype.sendCode = function (data) {
        return this.http.post(this.sendCodeUrl, data, this.httpOptions)
            .pipe(catchError(this.handleError('sendCode', null)));
    };
    ApiService.prototype.loginInPhoneOrAccount = function (data, requestOptions) {
        var _this = this;
        var withToken = !requestOptions || requestOptions.withToken !== false;
        var httpOptions = withToken
            ? this.httpOptions
            : {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                })
            };
        return this.http.post(this.loginInPhoneOrAccountUrl, data, httpOptions)
            .pipe(tap(function (res) {
            if (res) {
                _this.storeService.notification.notAuthed.next(null);
            }
        }), catchError(this.handleError('loginInPhoneOrAccount', null)));
    };
    ApiService.prototype.validateProtectionAccount = function (data) {
        return this.http.post(this.validateProtectionAccountUrl, data, this.httpOptions)
            .pipe(catchError(this.handleError('validateProtectionAccount', null)));
    };
    ApiService.prototype.updatePassword = function (data) {
        return this.http.post(this.updatePasswordUrl, data, this.httpOptions)
            .pipe(catchError(this.handleError('updatePassword', null)));
    };
    ApiService.prototype.getUserInfo = function () {
        return this.http.get(this.getUserInfoUrl, this.httpOptions)
            .pipe(catchError(this.handleError('loginInPhoneOrAccount', null)));
    };
    ApiService.prototype.logout = function () {
        return this.http.get(this.logoutUrl, this.httpOptions)
            .pipe(catchError(this.handleError('logout', null)));
    };
    ApiService.prototype.getUserStatusAskingDuration = function () {
        return this.http.get(this.getUserStatusAskingDurationUrl, this.httpOptions)
            .pipe(catchError(this.handleError('userStatysAskingDuration', null)));
    };
    ApiService.prototype.onApply = function () {
        return this.http.get(this.applyUrl, this.httpOptions)
            .pipe(catchError(this.handleError('onApply', null)));
    };
    ApiService.prototype.registerUser = function (data) {
        return this.http.post(this.registerUserUrl, data, this.httpOptions)
            .pipe(catchError(this.handleError('registerUser', null)));
    };
    //项目列表接口和项目学习进度接口
    ApiService.prototype.getProjectProgress = function (projectId) {
        return this.http.get(hostUrl + 'ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=' + projectId, this.httpOptions)
            .pipe(catchError(this.handleError('getProjectProgress', null)));
    };
    //项目列表接口和项目学习进度接口
    ApiService.prototype.getSingleProjectProgress = function () {
        return this.http.get(hostUrl + 'ddilearner/v2/user/learning/projectProgress?needDetails=false', this.httpOptions)
            .pipe(catchError(this.handleError('getSingleProjectProgress', null)));
    };
    ApiService.prototype.getKasInfo = function (exerciseId, practiceId) {
        this.exerciseId = exerciseId;
        console.log(this.exerciseId);
        return this.http.get(hostUrl + ("sr/resolvingConflicts/reports/" + exerciseId + "/" + practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('getKasInfo', null)));
    };
    ApiService.prototype.getKasInfos = function (exerciseId, practiceId) {
        this.exerciseId = exerciseId;
        console.log(this.exerciseId);
        return this.http.get(hostUrl + ("api/practices/" + exerciseId + "/" + practiceId + "/report"), this.httpOptions)
            .pipe(catchError(this.handleError('getKasInfos', null)));
    };
    ApiService.prototype.getReportKas = function (exerciseId, practiceId) {
        this.exerciseId = exerciseId;
        console.log(this.exerciseId);
        return this.http.get(hostUrl + ("sr/practice/getReports/" + exerciseId + "/" + practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('getReportKas', null)));
    };
    ApiService.prototype.getNewReportKas = function (practiceId) {
        return this.http.get(hostUrl + ("wx/api/report/" + practiceId), this.httpOptions)
            .pipe(catchError(this.handleError('getNewReportKas', null)));
    };
    ApiService.prototype.getmultiKas = function (multiExerciseMetaId) {
        return this.http.get(hostUrl + ("api/multiFinish/" + multiExerciseMetaId), this.httpOptions)
            .pipe(catchError(this.handleError('getmultiKas', null)));
    };
    //获取当前项目下课程分类
    ApiService.prototype.getProjectSort = function (projectId) {
        return this.http.get(hostUrl + ("ddilearner/v3/project/category?projectId=" + projectId), this.httpOptions)
            .pipe(catchError(this.handleError('getProjectSort', null)));
    };
    //获取项目下的课程分类详细数据
    ApiService.prototype.getProjectSortList = function (projectId, type) {
        return this.http.get(hostUrl + ("ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=" + projectId + "&type=" + type), this.httpOptions)
            .pipe(catchError(this.handleError('getProjectSortList', null)));
    };
    //查询用户学习进度
    ApiService.prototype.getUserQueryLearningProgress = function (learningPathMetaId) {
        return this.http.get(hostUrl + ("ddilearner/v2/user/learning/progress?learningPathMetaIds=" + learningPathMetaId), this.httpOptions)
            .pipe(catchError(this.handleError('getUserQueryLearningProgress', null)));
    };
    ApiService.prototype.getLevelInfo = function (reports) {
        var that = this;
        $.ajax({
            url: hostUrl + "sr/insideapi/getlevel",
            type: "post",
            dataType: "json",
            contentType: "application/json;charset=utf-8",
            data: JSON.stringify(this.getKaList(reports)),
            async: false,
            headers: {
                'transtalen-token': this.tokenService.findToken(),
                'transtalenuserid': this.tokenService.findUserIdEncoder()
            },
            success: function () { },
            error: function (err) {
                if (err.status === 401 && Number(err.responseJSON.code) === 106) {
                    that.storeService.notification.notAuthed.next(true);
                }
            }
        });
    };
    ApiService.prototype.getKaList = function (report) {
        var kaJson = {
            id: report.id,
            name: report.name,
            type: report.type,
            kas: {},
            exercisesId: this.exerciseId,
            questionId: null,
            optionId: null,
        };
        if (window["exercises" + this.exerciseId] != null) {
            var exerciseConfig = window["exercises" + this.exerciseId];
            kaJson.questionId = exerciseConfig.questionId;
            kaJson.optionId = exerciseConfig.optionId;
        }
        if (report) {
            for (var i = 0; i < report.kas.length; i++) {
                var kaItem = report.kas[i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
                    kaJson.kas[kaItem.name] = kaItem.value;
                }
            }
        }
        return kaJson;
    };
    //获取版本信息
    ApiService.prototype.getVersionData = function () {
        var headers = this.updateHeaders();
        headers['Accept'] = '*/*';
        var httpOptions = {
            headers: new HttpHeaders(headers)
        };
        console.log('httpOptions', httpOptions);
        return this.http.get(this.versionUrl, httpOptions).pipe(catchError(this.handleError('getVersionData', null)));
    };
    ApiService.prototype.ajax = function (object) {
        this.objUrl = object.url;
        if (object.url.indexOf("http://") == 0 || object.url.indexOf("https://") == 0) {
            this.objUrl = object.url;
        }
        else {
            //删除接口衔接处多余的斜杠
            var hostUrlHasSlashEnd = hostUrl[hostUrl.length - 1] === '/';
            var objectUrlHasSlashHead = object.url[0] === '/';
            var rewriteHostUrl = "";
            if (hostUrlHasSlashEnd && objectUrlHasSlashHead) {
                this.objUrl = hostUrl.slice(0, hostUrl.length - 1) + object.url;
            }
            else {
                this.objUrl = hostUrl + object.url;
            }
        }
        var type = object.type ? object.type.toLowerCase() : 'get';
        var data = object.data ? object.data : {};
        if (type == 'get') {
            return this.http.get(this.objUrl, this.httpOptions)
                .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
        }
        else if (type == 'post') {
            return this.http.post(this.objUrl, data, this.httpOptions)
                .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
        }
        else if (type == 'patch') {
            return this.http.patch(this.objUrl, data, this.httpOptions)
                .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
        }
        else if (type == 'put') {
            return this.http.put(this.objUrl, data, this.httpOptions)
                .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
        }
    };
    ApiService.prototype.loadConfig = function (url) {
        return this.http.get(url, this.httpOptions)
            .pipe(catchError(this.handleError('ajax', null)));
    };
    ApiService.prototype.handleError = function (operation, result) {
        var _this = this;
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // error reporting to server side is done in app-error-handler
            var postData = {
                errorMsg: JSON.stringify(error)
            };
            $.ajax({
                url: hostUrl + "sr/exposeoutapi/adderrormsg",
                type: "POST",
                contentType: 'application/json;charset=utf-8',
                data: JSON.stringify(postData),
                dataType: "JSON",
                headers: {
                    'transtalen-token': _this.tokenService.findToken(),
                    'transtalenuserid': _this.tokenService.findUserIdEncoder()
                },
                success: function (data) {
                    if (data.success) {
                        //alert("错误信息已经发送,不要重复提交");
                    }
                }
            });
            // if(this.testEnvironment.indexOf(window.location.hostname) === -1) {
            //   this.outOfSurveillance.indexOf(this.objUrl) === -1 ?  this.inSurveillanceFun(error) : this.outOfSurveillanceFun(error);
            // }else{
            //   this.outOfSurveillanceFun(error);
            // }
            _this.inSurveillanceFun(error);
            //错误处理
            _this.responseErrHandler(error);
            // Let the app keep running by returning an empty result.
            return throwError(error); //将错误继续传递到页面
            // return of(result as T);
        };
    };
    // 监控内
    ApiService.prototype.inSurveillanceFun = function (error) {
        if (error.status === 403) {
            this.router.navigate(['new-login']);
        }
        // if (error.status === 401) {
        //   // const domain = window.location.hostname;
        //   // const referUrl = encodeURIComponent(window.location.href);
        //   // window.location.href = '/api/login?domain=' + domain + '&referUrl=' + referUrl;
        //   this.storeService.notification.notAuthed.next(true);
        // }else if(error.status === 404){
        //   this.router.navigate(['error','404']);
        // }else if(error.status === 500&& error.url.indexOf('/api/jsapi')===-1){
        //   console.log("test error.url="+error.url);
        //   console.log("test error: = "+(error.url.indexOf('/api/jsapi')===-1));
        //   //this.router.navigate(['error','500']);
        // } else{
        //   this.router.navigate(['error','500']);
        // }
    };
    // 监控外
    ApiService.prototype.outOfSurveillanceFun = function (error) {
        if (error.status === 401) {
            //未授权,登录状态改为false
            this.storeService.notification.notAuthed.next(true);
        }
    };
    //全局错误处理器
    ApiService.prototype.responseErrHandler = function (error) {
        // console.log('响应错误---',error)
        if (error.status === 401) {
            var url = (error.url || '') + '';
            if (url.indexOf('/v1/user/login') > -1) {
                return;
            }
            this.storeService.notification.notAuthed.next(true);
        }
        else {
            console.log('message:' + JSON.stringify(error));
        }
    };
    return ApiService;
}());
export { ApiService };



// WEBPACK FOOTER //
// ./src/app/api.service.ts.pre-build-optimizer.js